import { Spacer } from '@zillow/constellation';
import { Heading, Image, Text } from '@zillow/constellation-10';

import { CREATE_LEASE_CONTENT } from '../constants';
import type { STEPS } from '../constants';

import { StyledHeroBackground } from '../StyledComponents';

type Props = {
  step: (typeof STEPS)[keyof typeof STEPS] & string;
};

const CreateLease = ({ step }: Props) => {
  return (
    <div data-testid="CreateLease">
      <StyledHeroBackground data-testid="CreateLeaseHero" display="flex" alignItems="center" justifyItems="center">
        <Image src={CREATE_LEASE_CONTENT[step].HERO_IMAGE} alt={CREATE_LEASE_CONTENT[step].HERO_IMAGE_ALT} />
      </StyledHeroBackground>

      <Spacer marginBottom="sm" />

      <Spacer data-testid="CreateLeaseContentContainer" marginBottom="sm">
        <Heading level={4}>{CREATE_LEASE_CONTENT[step].HEADING}</Heading>

        <Spacer marginBottom="sm" />

        <Text asChild>
          <p>{CREATE_LEASE_CONTENT[step].BODY}</p>
        </Text>
      </Spacer>
    </div>
  );
};

export default CreateLease;
